import { DEFAULT_STATE } from '../constants'

export const initialThreeDOnlyState = {
  animated: DEFAULT_STATE.animated,
  pbr: DEFAULT_STATE.pbr,
  rigged: DEFAULT_STATE.rigged,
}
